import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const containerStyles: AbgSxProps = {
  display: 'flex',
  overflowX: { xs: 'hidden', md: 'auto' },
  whiteSpace: 'nowrap',
  scrollbarWidth: 'thin',
  maxWidth: { lg: 'none' },
  padding: { xs: '0px 16px', md: '0px 56px' },

  '& .MuiBreadcrumbs-li': {
    display: 'flex',
    alignItems: 'center',
  },
};

export const iconStyles: AbgSxProps = {
  fontSize: 8,
  color: paletteBase.secondary400,
};
